import { __awaiter, __generator } from "tslib";
import { ServiceType } from '@gn-audio/core/api/product-catalogue/enums/service-type';
import { getServiceForProduct } from './../../../utilities/get-service-for-product';
export var getEngravingPreviewImageUrl = function (productSku) { return __awaiter(void 0, void 0, void 0, function () {
    var linkedEngraving, widthDimention, heightDimention, defaultPreviewImageUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getServiceForProduct(productSku, ServiceType.Engraving)];
            case 1:
                linkedEngraving = _a.sent();
                widthDimention = 455;
                heightDimention = 300;
                defaultPreviewImageUrl = "https://www.jabra.com/-/media/F45399F075BE45A48A0EDEB5F8CF95B6.ashx";
                return [2 /*return*/, (linkedEngraving === null || linkedEngraving === void 0 ? void 0 : linkedEngraving.thumbnailUrl)
                        ? "".concat(linkedEngraving.thumbnailUrl, "?w=").concat(widthDimention, "&h=").concat(heightDimention)
                        : defaultPreviewImageUrl];
        }
    });
}); };
